/**
 * 数据榜单
 */
<template>
  <div>
    <div class="container-list">
      <!-- 商务精英榜 -->
      <div class="list" style="margin-right: auto;">
        <div style="margin: 20px;">
          <div style="display: flex;">
            <div style="margin-right: auto;height: 28px;display: flex;">
              <div style="width: 35px;height: 28px;">
                <el-image style="width: 100%;height: 100%;" :src="cup_url" fit="cover"></el-image>
              </div>
              <div style="font-weight: 700;font-size: 24px;margin-left: 10px;">商务精英榜</div>
            </div>
            <div style="margin-left: auto;height: 40px;line-height: 40px;width: 140px;display: flex;">
              <div class="list-choose leftRa" :class="[leftCh ? 'choose' : '']" @click="chooseList('leftCh')">月</div>
              <div class="list-choose rightRa" :class="[rightCh ? 'choose' : '']" @click="chooseList('rightCh')">年</div>
            </div>
          </div>
          <!-- 表格 -->
          <el-table size="small" 
          :data="monthS" 
          highlight-current-row 
          v-loading="loading" 
          border element-loading-text="拼命加载中"
          :header-cell-style="{'color':'#333333'}"
          :stripe="true"
          style="width: 100%;margin-top: 16px;" v-if="leftCh">
             <el-table-column prop="rank" label="当前排名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="admin_name" label="商务人员" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="money" label="服务业绩" align="center" show-overflow-tooltip>
            </el-table-column>
          </el-table>
           <el-table size="small" 
          :data="yearS" 
          highlight-current-row 
          v-loading="loading" 
          border element-loading-text="拼命加载中"
          :header-cell-style="{'color':'#333333'}"
          :stripe="true"
          style="width: 100%;margin-top: 16px;" v-if="rightCh">
             <el-table-column prop="rank" label="当前排名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="admin_name" label="商务人员" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="money" label="服务业绩" align="center" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- 专利卫士榜 -->
      <div class="list" style="margin-left: auto;"> 
          <div style="margin: 20px;">
          <div style="display: flex;">
            <div style="margin-right: auto;height: 28px;display: flex;">
              <div style="width: 35px;height: 28px;">
                <el-image style="width: 100%;height: 100%;" :src="cup_url" fit="cover"></el-image>
              </div>
              <div style="font-weight: 700;font-size: 24px;margin-left: 10px;">专利卫士榜</div>
            </div>
            <div style="margin-left: auto;height: 40px;line-height: 40px;width: 140px;display: flex;">
              <div class="list-choose leftRa" :class="[leftWechatCh ? 'choose' : '']" @click="chooseWechatList('leftWechatCh')">月</div>
              <div class="list-choose rightRa" :class="[rightWechatCh ? 'choose' : '']" @click="chooseWechatList('rightWechatCh')">年</div>
            </div>
          </div>
          <!-- 表格 -->
          <el-table size="small" 
          :data="monthW" 
          highlight-current-row 
          v-loading="loading" 
          border element-loading-text="拼命加载中"
          :header-cell-style="{'color':'#333333'}"
          :stripe="true"
          style="width: 100%;margin-top: 16px;" v-if="leftWechatCh">
             <el-table-column prop="rank" label="当前排名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="推广人员" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="number" label="推广数" align="center" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <el-table size="small" 
          :data="yearW" 
          highlight-current-row 
          v-loading="loading" 
          border element-loading-text="拼命加载中"
          :header-cell-style="{'color':'#333333'}"
          :stripe="true"
          style="width: 100%;margin-top: 16px;" v-if="rightWechatCh">
             <el-table-column prop="rank" label="当前排名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="推广人员" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="number" label="推广数" align="center" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="bottom-list">
       <el-table size="small" :data="cenData" highlight-current-row :stripe="true" v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
             <el-table-column prop="label" label="业绩总览" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="month" label="月度累计" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="quarter" label="季度累计" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="year" label="年度累计" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="history" label="历史累计" align="center" show-overflow-tooltip>
            </el-table-column>
       </el-table>
    </div>
  </div>
</template>

<script>
import { getRankData } from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      cup_url: require('../../assets/img/cup.png'),
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      leftCh: true,
      rightCh: false,
      leftWechatCh: true,
      rightWechatCh: false,
      title: '添加',
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      monthS: [],
      yearS: [],
      monthW: [],
      yearW: [],
      userData: [],
      invData: [],
      cenData: [],

      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        ps: 10,
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      busData: [], //商务精英数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    this.getRank()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取榜单数据
    getRank() {
      getRankData()
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.monthS = res.data.monthS
            this.yearS = res.data.yearS
            this.cenData = res.data.userData
            this.monthW = res.data.monthW
            this.yearW = res.data.yearW
        }
      })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 选择榜单(商务精英)
    chooseList(keyword) {
      console.log(keyword)
      if(keyword == 'leftCh'){
        this.rightCh = false
        this.leftCh = true
      }else{
        this.leftCh = false
        this.rightCh = true
      }
    },
    // 选择榜单(专利卫士)
    chooseWechatList(keyword) {
      console.log(keyword)
      if(keyword == 'leftWechatCh'){
        this.rightWechatCh = false
        this.leftWechatCh = true
      }else{
        this.leftWechatCh = false
       this.rightWechatCh = true
      }
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.container-list {
  display: flex;
  margin-top: 20px;
}
.list {
  width: 49.5%;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  min-height: 300px;
}
.bottom-list {
  /* border: 1px solid #E0E0E0; */
  border-radius: 10px;
  width: 100%;
  min-height: 200px;
  margin-top: 20px;
}
.list-choose {
  width: 50%;
  text-align: center;
  height: 28px;
  line-height: 28px;
  font-size: 16px;
  font-weight: 700;
  color: #6D6D6D;
  background-color: #F5F5F5;
  cursor: pointer;
}
.leftRa {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rightRa {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.choose {
  color: #FFFFFF;
  background-color: #00C8DF;
}
.el-table--border,.el-table--group {
  border-radius: 10px !important;
}
.el-table thead {
  background-color: #E0E0E0 !important;
  color: #333333 !important;
  font-weight: 700 !important;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/crm/list.vue